import { createApiRef } from '@backstage/core-plugin-api';
import { IEpDevPSearchApiClient } from '@solace-labs/backstage-plugin-ep-devp-search-common';
import { EpDevPPluginIds } from '@solace-labs/backstage-plugin-ep-devp-common';

export const epDevPSearchApiClientApiRef = createApiRef<IEpDevPSearchApiClient>({
  id: `${EpDevPPluginIds.EpDevPSearchPluginId}.api-ref`
});
